import React from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { Graph } from 'react-d3-graph';
import BlankState from '../BlankState';
import * as taskOps from '../../../api/Tasks/task-operations';

const { isBeta } = Meteor.settings.public;

const comingSoonProps = {
  icon: { style: 'solid', symbol: 'cogs' },
  title: 'This feature is not ready yet. Coming Soon',
  subtitle: ''
};

const TaskerGraph = ({ task, selectNode, myConfig }) => {
  if (isEmpty(task)) {
    return <Alert variant="info">Please select a Task</Alert>;
  }
  if (!isBeta && !taskOps.isReady(task)) return <BlankState {...comingSoonProps} />;

  return (
    <div className="border border-dark">
      <Graph
        id="graph-task" // id is mandatory, if no id is defined rd3g will throw an error
        data={task}
        className="border border-primary"
        config={myConfig}
        onClickNode={selectNode}
      />
    </div>
  );
};

TaskerGraph.propTypes = {
  task: PropTypes.object.isRequired,
  selectNode: PropTypes.func.isRequired,
  myConfig: PropTypes.object.isRequired
};
export default TaskerGraph;
